import { getFunctions, httpsCallable } from '../../firebase';
import { BLACKA_CHAT_FUNCTION, BLACKA_SITE_URL } from '../../config/blackaChat';
import { createLogger } from '../../utils/logger';
import type { BlackaChatRequest, BlackaChatResponse } from '../../types/chat';

const logger = createLogger('blackaChatService');

/**
 * Send a message to the Blacka Cloud Function (Gemma 4 on Vertex AI).
 */
export async function sendBlackaMessage(
  request: BlackaChatRequest
): Promise<BlackaChatResponse> {
  const callable = httpsCallable(getFunctions(), BLACKA_CHAT_FUNCTION);
  const payload = {
    ...request,
    siteUrl: request.siteUrl || BLACKA_SITE_URL,
  };

  try {
    const result = await callable(payload);
    const data = result.data as BlackaChatResponse;
    if (!data?.reply) {
      throw new Error('No reply from Blacka');
    }
    return data;
  } catch (error) {
    logger.error('[sendBlackaMessage] Cloud Function call failed:', error);
    throw error;
  }
}
